import { useAppState } from "src/state"

import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { OperationsAdminHomeLinkCard } from "src/components/operations/administrator/OperationsAdminHomeLinkCards"
    
export const OperationsAdminHome = () => {

    const userName = useAppState(state=>state.user_name)

    return (
        <PageLayout
            header={<PageHeader
                title={`Welcome ${userName}`}
            />
        }>
            <OperationsAdminHomeLinkCard />
        </PageLayout>
    )
}